import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";
import type { ReactNode } from "react";

import { AbilityInfoCard } from "./AbilityInfoCard";
import { InfoPopover } from "./InfoPopover";

const LABEL = msg({ id: "matches.ability_info.label", message: "Description of ability {name}" });

type AbilityInfoProps = {
  abilityId: number;
  // Название умения — для подписи кнопки экранному диктору.
  name: string;
  // Значок или значок с названием: становится кнопкой.
  children: ReactNode;
  // Строка внизу описания: на каких шагах прокачки его качают сильные.
  footer?: ReactNode;
  className?: string;
};

// Умение, которое показывает описание как в игре: на компьютере — окном при наведении
// (нажатие закрепляет), на телефоне — шторкой снизу по нажатию.
export const AbilityInfo = ({ abilityId, name, children, footer, className }: AbilityInfoProps) => {
  const { _ } = useLingui();
  return (
    <InfoPopover
      label={_({ ...LABEL, values: { name } })}
      title={name}
      className={className}
      renderCard={({ renderTitle, closeButton }) => (
        <AbilityInfoCard
          abilityId={abilityId}
          footer={footer}
          renderTitle={renderTitle}
          closeButton={closeButton}
        />
      )}
    >
      {children}
    </InfoPopover>
  );
};
